import { showToastMessage } from '../../../utils/AppUtils';

export const RATE_CARD_SHARE_EMAIL_SUBJECT = 'My creator rate card on Thspian';

export function rateCardShareEmailBody(rateCardLink: string, creatorName?: string): string {
    const who = creatorName?.trim() ? creatorName.trim() : 'me';
    return `Hey!\n\nCheck out ${who}'s rate card on Thspian:\n\n${rateCardLink}\n\nHappy to collab!`;
}

export async function copyRateCardLink(rateCardLink: string): Promise<boolean> {
    try {
        await navigator.clipboard.writeText(rateCardLink);
        showToastMessage('Rate card link copied', 'success');
        return true;
    } catch {
        showToastMessage('Could not copy link', 'error');
        return false;
    }
}

export function openRateCardEmailShare(rateCardLink: string, creatorName?: string): void {
    const subject = encodeURIComponent(RATE_CARD_SHARE_EMAIL_SUBJECT);
    const body = encodeURIComponent(rateCardShareEmailBody(rateCardLink, creatorName));
    window.open(`mailto:?subject=${subject}&body=${body}`, '_self');
}
